/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import App from "../helpers/app";
import noUiSlider from "nouislider";

let PluginNoUiSlider = new function(){
    let me = this;

    this.update = function ($el, $position) {
        if($el.width()*$position/100>$el.find('.noUi-touch-area').width()/2 && !$el.hasClass('show-before')){
            $el.addClass('show-before');
        }else if($el.width()*$position/100<$el.find('.noUi-touch-area').width()/2 && $el.hasClass('show-before')){
            $el.removeClass('show-before');
        }
    };

    this.init = function(obj){
        obj.find('[data-plugin-nouislider]').each(function(){
            let plugin = $(this);

            me.create(plugin);
        });
    };

    this.create = function (plugin, defaults){
        if(plugin.next('.noUi-target').length){
            return plugin.next('.noUi-target').get(0);
        }

        let start = 0;
        let el = plugin[0];
        if(plugin.is('input')){
            el = $('<div></div>');

            start = plugin.val().split(':');
            el.insertAfter(plugin);

            el = el[0];
        }

        let config = $.extend(true, {}, App.getPluginConfig(plugin, 'plugin-nouislider', {
            start: start,
            step: 1,
            connect: start.length > 1 ? true : 'lower',
            range: {
                min: 0,
                max: 100000
            },
            format: {
                to: function (value) {
                    return value.toFixed(0);
                },
                from: function (value) {
                    return value;
                }
            },
            cssClasses: {
                target: "target",
                base: "base",
                origin: "origin",
                handle: "handle",
                handleLower: "handle-lower",
                handleUpper: "handle-upper",
                touchArea: "touch-area",
                horizontal: "horizontal",
                vertical: "vertical",
                background: "background",
                connect: "connect",
                connects: "connects",
                ltr: "ltr",
                rtl: "rtl",
                draggable: "draggable",
                drag: "state-drag",
                tap: "state-tap",
                active: "active",
                tooltip: "tooltip",
                pips: "pips",
                pipsHorizontal: "pips-horizontal",
                pipsVertical: "pips-vertical",
                marker: "marker",
                markerHorizontal: "marker-horizontal",
                markerVertical: "marker-vertical",
                markerNormal: "marker-normal",
                markerLarge: "marker-large",
                markerSub: "marker-sub",
                value: "value",
                valueHorizontal: "value-horizontal",
                valueVertical: "value-vertical",
                valueNormal: "value-normal",
                valueLarge: "value-large",
                valueSub: "value-sub"
            }
        }), defaults);

        let theme = 'default';
        if(typeof config.theme !== 'undefined'){
            theme = config.theme;
        }

        config.plugin.cssClasses.ltr = theme+'-theme';
        if(typeof start === 'object' && start.length > 1){
            config.plugin.cssClasses.ltr += ' noUi-mode-range'
        }else{
            config.plugin.cssClasses.ltr += ' noUi-mode-single'
        }

        noUiSlider.create(el, config.plugin);

        if(typeof config.connectedPagination !== 'undefined'){
            let connectedPagination = $(config.connectedPagination);
            if(connectedPagination.length){
                connectedPagination.on('click', '.page', function (){
                    let value = $(this).data('page');
                    el.noUiSlider.set(value);
                });
            }
        }

        if(typeof config.connectedNavigation !== 'undefined'){
            let connectedNavigation = $(config.connectedNavigation);
            if(connectedNavigation.length){
                connectedNavigation.find('.prev').click(function (){
                    let steps = el.noUiSlider.steps();
                    let stepValue = steps[0][0] ?? null;
                    let value = Number.parseFloat(el.noUiSlider.get());
                    if (stepValue !== null) {
                        el.noUiSlider.set(value - stepValue);
                    }
                });
                connectedNavigation.find('.next').click(function (){
                    let steps = el.noUiSlider.steps();
                    let stepValue = steps[0][1] ?? null;
                    let value = Number.parseFloat(el.noUiSlider.get());
                    if (stepValue !== null) {
                        el.noUiSlider.set(value + stepValue);
                    }
                });
            }
        }

        if(typeof config.connectedInput !== 'undefined'){
            if(typeof config.connectedInput === 'string'){
                config.connectedInput = [config.connectedInput];
            }

            for(let connectedInputIndex = 0; connectedInputIndex < config.connectedInput.length; connectedInputIndex++){
                let connectedInput = $(config.connectedInput[connectedInputIndex]);
                let connectedInputHtml = !connectedInput.is('input');

                if(connectedInput.length){
                    el.noUiSlider.on('update.connectedInput', function (values) {
                        if(connectedInputHtml){
                            connectedInput.html(config.connectedInput.length > 1 ? values[connectedInputIndex] : values.join(':'));
                        }else{
                            connectedInput.val(config.connectedInput.length > 1 ? values[connectedInputIndex] : values.join(':'));
                            connectedInput[0].dispatchEvent(new Event('change'));
                        }
                    });

                    connectedInput.keydown(function (e){
                        if (!e.key.match(/^[0-9]/g) && $.inArray(e.keyCode, [8, 46, 37, 39])===-1) {
                            e.preventDefault();
                        }
                    });

                    connectedInput.blur(function () {
                        let values = [];
                        if(config.connectedInput.length > 1){
                            for(let connectedInputIndexSub = 0; connectedInputIndexSub < config.connectedInput.length; connectedInputIndexSub++){
                                let connectedInputSub = $(config.connectedInput[connectedInputIndexSub]);
                                let connectedInputHtmlSub = !connectedInputSub.is('input');

                                values.push(connectedInputHtmlSub ? connectedInputSub.text() : connectedInputSub.val());
                            }
                        }else{
                            values = connectedInputHtml ? $(this).text().split(':') : $(this).val().split(':');
                        }

                        el.noUiSlider.set(values);
                    });
                }
            }
        }

        if(typeof config.events !== 'undefined'){
            $.each(config.events, function(k,v){
                let func;
                eval('func = '+v+';');
                if(typeof func==='function'){
                    el.noUiSlider.on(k+'.config', func);
                }else{
                    delete config.events[k];
                }
            });
        }

        el.noUiSlider.on('update.customize', function (values, handle, unencoded, tap, positions) {
            el.noUiSlider.off('update.customize');

            $(el.noUiSlider.target).find('.noUi-handle-lower').attr('aria-label', 'Zmień wartość');
        });

        if(plugin.is('input')){
            el.noUiSlider.on('update.init', function (values, handle, unencoded, tap, positions) {
                let value = values.join(':');
                if(value!==plugin.val()){
                    plugin.val(value);
                }

                me.update($(el.noUiSlider.target), positions);
            });
            el.noUiSlider.on('set.init', function (values, handle, unencoded, tap, positions) {
                plugin.change();

                me.update($(el.noUiSlider.target), positions);
            });
            el.noUiSlider.on('slide.init', function (values, handle, unencoded, tap, positions) {
                me.update($(el.noUiSlider.target), positions);
            });
        }

        return el;
    };
};

export default PluginNoUiSlider;
